// Auto-generated by backend/generate_i18n_supplement.py — fills missing
// react-i18next keys for fr/de/es/ru/zh/ja/ko/hi (merged with overwrite=false).
export const I18N_SUPPLEMENT = {
 "fr": {
  "appName": "Manasik",
  "tagline": "Le Guide le Plus Complet de la Omra et du Hajj",
  "home": "Accueil",
  "guide": "Manasik",
  "prayers": "Prière",
  "map": "Carte",
  "profile": "Profil",
  "login": "Entrer",
  "register": "S'inscrire",
  "email": "E-mail",
  "password": "Mot de passe",
  "name": "Nom Complet",
  "logout": "Quitter",
  "loginTitle": "Bon Retour",
  "registerTitle": "Créer un compte",
  "noAccount": "Vous n'avez pas de compte ?",
  "haveAccount": "Vous avez déjà un compte?",
  "greeting": "Assalamu'alaikum",
  "journeyProgress": "Progression du Voyage",
  "startGuide": "Commencer le Manasik",
  "viewPrayers": "Voir la Supplication",
  "quickChecklist": "Liste de Préparation",
  "costCalculator": "Calculateur de coûts",
  "umrah": "Omra",
  "hajj": "Hajj",
  "steps": "Étapes",
  "markComplete": "Marquer comme terminé",
  "completed": "Terminé",
  "historicalContext": "L'Histoire de la Biographie Prophétique",
  "watchGuide": "Guide Visuel",
  "arabic": "Arabe",
  "transliteration": "Latin",
  "playAudio": "Lire l'audio",
  "source": "Source",
  "allPrayers": "Toutes les Prières",
  "mapTitle": "Carte des Lieux Saints",
  "mapSubtitle": "Explorez les lieux nobles des manasiks",
  "tripType": "Type d'Adoration",
  "tripDate": "Date de Départ",
  "save": "Enregistrer",
  "saved": "Enregistré",
  "completedSteps": "Étape Terminée",
  "account": "Compte",
  "loading": "Chargement...",
  "budget": "Budget (par jour)",
  "days": "Nombre de Jours",
  "totalCost": "Coût Total Estimé",
  "daysRemaining": "jours restants",
  "calcHint": "Calculez le coût estimé de votre voyage",
  "complete": "Terminé",
  "welcomeSub": "Commencez votre voyage spirituel avec un guide complet.",
  "qari": "Voix du Récitant",
  "qariHint": "Audio favori enregistré dans le compte et synchronisé sur tous les appareils",
  "favoriteSaved": "Récitateurs favoris enregistrés",
  "preview": "Écoutez l'exemple",
  "previewUnavailable": "L'audio d'exemple n'est pas encore disponible",
  "searchPrayers": "Rechercher des invocations (titre, latin, traduction)...",
  "noResults": "Aucune prière appropriée trouvée",
  "favorites": "Favoris",
  "addFavorite": "Marquer comme favori",
  "tasbih": "Tasbih Numérique",
  "tasbihHint": "Appuyez sur le cercle pour faire dhikr · vibration active",
  "rounds": "Tours",
  "download": "Télécharger l'audio",
  "downloaded": "Audio enregistré pour écouter sans signal",
  "downloadFailed": "Échec de l'enregistrement audio",
  "saveOffline": "Enregistrer pour hors ligne",
  "savedOffline": "Enregistré hors ligne",
  "removedOffline": "Audio hors ligne supprimé",
  "videoGuides": "Vidéo Guide",
  "videoGuidesHint": "Regardez le guide des procédures d'Umrah et de Hajj étape par étape",
  "videoDisclaimer": "Cette vidéo est un contenu public tiers (YouTube) et ses droits d'auteur appartiennent à leurs propriétaires respectifs.",
  "quranTitle": "Le Coran & Exégèse",
  "quranHint": "Lisez 114 sourates avec traduction, audio et tafsir Kemenag",
  "times": "Heures de Prière",
  "qibla": "Direction de la Qibla",
  "nextPrayer": "Prochaine Prière",
  "locating": "Détection de la localisation...",
  "relocate": "Mettre à jour la localisation",
  "qiblaHint": "L'aiguille indique la direction de la Ka'bah depuis votre position",
  "fromNorth": "depuis la direction Nord",
  "enableCompass": "Activer la Boussole",
  "compassActive": "Boussole active — orientez votre téléphone à l'horizontale",
  "calcMethod": "Méthode de Calcul",
  "reminders": "Rappel de l'Appel à la Prière",
  "remindersHint": "Un doux rappel avant & pendant les heures de prière",
  "minutesBefore": "minutes avant",
  "remindersEnabled": "Le rappel de l'appel à la prière a été activé",
  "remindersInApp": "Notifications de l'appareil refusées — les rappels s'afficheront toujours dans l'application",
  "remindersBackground": "Rappel d'arrière-plan actif — reste visible même lorsque l'application est fermée",
  "adhanSound": "Le Son de l'Adhan",
  "adhanSoundHint": "Adhan authentique de la Masjidil Haram de La Mecque, diffusé automatiquement à l'entrée des heures de prière (application ouverte)",
  "adhanPreview": "Essayer l'Azan",
  "adhanPreviewFajr": "Essayer l'Adhan du Fajr",
  "adhanStop": "Arrêtez",
  "adhanPlaying": "En cours d'appel…",
  "notifSoonTitle": "Avant {{prayer}}",
  "notifSoonBody": "{{min}} minutes avant l'heure de {{prayer}}",
  "notifNowTitle": "Heure de {{prayer}}",
  "notifNowBody": "Le temps de la prière {{prayer}} est arrivé. Préparons-nous pour la prière.",
  "packages": "Forfait",
  "verifyEmailSentTitle": "Vérifiez votre e-mail",
  "verifyEmailSentBody": "Nous avons envoyé un lien de vérification à {{email}}. Cliquez sur le lien pour activer votre compte.",
  "verifyEmailResend": "Renvoyer l'e-mail de vérification",
  "verifyEmailResent": "L'e-mail de vérification a été renvoyé",
  "verifyingEmail": "Vérification de votre e-mail...",
  "verifyEmailSuccess": "Votre adresse e-mail a été vérifiée avec succès !",
  "verifyEmailFailed": "Le lien de vérification est invalide ou a expiré.",
  "emailNotVerified": "Votre adresse e-mail n'a pas été vérifiée. Veuillez vérifier votre boîte de réception.",
  "backToLogin": "Retour à la page de connexion",
  "verifyEmailCheckSpam": "Vous n'avez pas reçu l'e-mail ? Vérifiez votre dossier spam.",
  "forgotPassword": "Mot de passe oublié ?",
  "forgotPasswordTitle": "Réinitialiser le mot de passe",
  "forgotPasswordBody": "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  "sendResetLink": "Envoyer le lien de réinitialisation",
  "resetSentBody": "Si l'e-mail est enregistré, nous avons envoyé un lien de réinitialisation à {{email}}.",
  "newPassword": "Nouveau mot de passe",
  "confirmPassword": "Confirmer le mot de passe",
  "passwordMismatch": "Les mots de passe ne correspondent pas",
  "passwordMinLen": "Le mot de passe doit comporter au moins 6 caractères",
  "updatePassword": "Mettre à jour le mot de passe",
  "resetPasswordSuccess": "Mot de passe mis à jour avec succès !",
  "resetPasswordFailed": "Le lien de réinitialisation est invalide ou a expiré.",
  "changePassword": "Changer le mot de passe",
  "currentPassword": "Mot de passe actuel",
  "changePasswordSuccess": "Mot de passe modifié avec succès",
  "currentPasswordWrong": "Le mot de passe actuel est incorrect",
  "avatarUpdated": "Photo de profil mise à jour",
  "avatarFailed": "Échec du téléchargement de la photo",
  "removePhoto": "Supprimer la photo",
  "photoRemoved": "Photo de profil supprimée",
  "cropTitle": "Recadrer la photo",
  "cancel": "Annuler",
  "zoomLabel": "Agrandir",
  "dragHint": "Faites glisser la photo pour ajuster la position",
  "faqTitle": "Questions et Réponses",
  "faqSub": "Questions générales sur le culte du Hajj et de la Omra",
  "healthTitle": "Conseils de Santé",
  "healthSub": "Maintenez votre endurance et votre santé pendant l'adoration",
  "prepTitle": "Préparation",
  "prepSub": "Matériel de préparation avant le départ",
  "noContentYet": "Le contenu sera disponible bientôt."
 },
 "de": {
  "appName": "Manasik",
  "tagline": "Der vollständigste Leitfaden für Umrah & Hadsch",
  "home": "Startseite",
  "guide": "Manasik",
  "prayers": "Gebet",
  "map": "Karte",
  "profile": "Profil",
  "login": "Eintreten",
  "register": "Registrieren",
  "email": "E-Mail",
  "password": "Passwort",
  "name": "Vollständiger Name",
  "logout": "Beenden",
  "loginTitle": "Willkommen Zurück",
  "registerTitle": "Konto erstellen",
  "noAccount": "Noch kein Konto?",
  "haveAccount": "Haben Sie bereits ein Konto?",
  "greeting": "Assalamu'alaikum",
  "journeyProgress": "Reisefortschritt",
  "startGuide": "Manasik beginnen",
  "viewPrayers": "Gebet anzeigen",
  "quickChecklist": "Vorbereitungsliste",
  "costCalculator": "Kostenkalkulator",
  "umrah": "Umra",
  "hajj": "Haddsch",
  "steps": "Phasen",
  "markComplete": "Als erledigt markieren",
  "completed": "Fertig",
  "historicalContext": "Die Geschichte der Prophetenbiographie",
  "watchGuide": "Visueller Leitfaden",
  "arabic": "Araber",
  "transliteration": "Latein",
  "playAudio": "Audio abspielen",
  "source": "Quelle",
  "allPrayers": "Alle Gebete",
  "mapTitle": "Karte der Heiligen Stätten",
  "mapSubtitle": "Erkunden Sie die edlen Stätten der Manasik",
  "tripType": "Art der Anbetung",
  "tripDate": "Abreisedatum",
  "save": "Speichern",
  "saved": "Gespeichert",
  "completedSteps": "Stufe Abgeschlossen",
  "account": "Konto",
  "loading": "Laden...",
  "budget": "Budget (pro Tag)",
  "days": "Anzahl der Tage",
  "totalCost": "Geschätzte Gesamtkosten",
  "daysRemaining": "Tage verbleibend",
  "calcHint": "Berechnen Sie Ihre geschätzten Reisekosten",
  "complete": "Fertig",
  "welcomeSub": "Beginnen Sie Ihre spirituelle Reise mit einem vollständigen Leitfaden.",
  "qari": "Stimme des Rezitatoren",
  "qariHint": "Lieblings-Audio im Konto gespeichert & auf allen Geräten synchronisiert",
  "favoriteSaved": "Lieblingsrezitatoren gespeichert",
  "preview": "Hören Sie sich das Beispiel an",
  "previewUnavailable": "Beispielaudio ist noch nicht verfügbar",
  "searchPrayers": "Gebete suchen (Titel, Latein, Übersetzung)...",
  "noResults": "Kein passendes Gebet gefunden",
  "favorites": "Favoriten",
  "addFavorite": "Als Favorit markieren",
  "tasbih": "Digitaler Tasbih",
  "tasbihHint": "Tippe auf den Kreis zum Dhikr · Vibration aktiv",
  "rounds": "Runden",
  "download": "Audio herunterladen",
  "downloaded": "Audio gespeichert zum Hören ohne Signal",
  "downloadFailed": "Audio speichern fehlgeschlagen",
  "saveOffline": "Für offline speichern",
  "savedOffline": "Offline gespeichert",
  "removedOffline": "Offline-Audio gelöscht",
  "videoGuides": "Anleitungsvideo",
  "videoGuidesHint": "Sehen Sie sich die Schritt-für-Schritt-Anleitung für Umrah & Hajj an",
  "videoDisclaimer": "Dieses Video ist öffentlicher Drittanbieter-Inhalt (YouTube) und das Urheberrecht liegt bei den jeweiligen Eigentümern.",
  "quranTitle": "Al-Qur'an & Tafsir",
  "quranHint": "Lesen Sie 114 Suren mit Übersetzung, Audio & Kemenag-Tafsir",
  "times": "Gebetszeiten",
  "qibla": "Qibla-Richtung",
  "nextPrayer": "Nächstes Gebet",
  "locating": "Standort wird erkannt...",
  "relocate": "Standort aktualisieren",
  "qiblaHint": "Die Nadel zeigt die Richtung der Ka'bah von Ihrem Standort an",
  "fromNorth": "aus der Richtung Norden",
  "enableCompass": "Kompass Aktivieren",
  "compassActive": "Kompass aktiv — halten Sie Ihr Telefon waagerecht",
  "calcMethod": "Berechnungsmethode",
  "reminders": "Gebetsruf-Erinnerung",
  "remindersHint": "Eine sanfte Erinnerung vor & während der Gebetszeiten",
  "minutesBefore": "Minuten vorher",
  "remindersEnabled": "Adhan-Erinnerung wurde aktiviert",
  "remindersInApp": "Gerätebenachrichtigungen abgelehnt — Erinnerungen werden weiterhin in der App angezeigt",
  "remindersBackground": "Aktive Hintergrunderinnerung — bleibt sichtbar, auch wenn die App geschlossen ist",
  "adhanSound": "Der Klang des Adhan",
  "adhanSoundHint": "Authentischer Adhan aus der Masjidil Haram Mekka, wird automatisch beim Eintreten der Gebetszeiten abgespielt (App geöffnet)",
  "adhanPreview": "Azan ausprobieren",
  "adhanPreviewFajr": "Fajr-Adhan ausprobieren",
  "adhanStop": "Stopp",
  "adhanPlaying": "Wird gerade gerufen…",
  "notifSoonTitle": "Vor {{prayer}}",
  "notifSoonBody": "{{min}} Minuten bis zur {{prayer}}-Zeit",
  "notifNowTitle": "Zeit von {{prayer}}",
  "notifNowBody": "Die Zeit für das {{prayer}}-Gebet ist eingetreten. Lasst uns zum Gebet bereit machen.",
  "packages": "Paket",
  "verifyEmailSentTitle": "Überprüfen Sie Ihre E-Mail",
  "verifyEmailSentBody": "Wir haben einen Bestätigungslink an {{email}} gesendet. Klicken Sie auf den Link, um Ihr Konto zu aktivieren.",
  "verifyEmailResend": "Verifizierungs-E-Mail erneut senden",
  "verifyEmailResent": "Verifizierungs-E-Mail wurde erneut gesendet",
  "verifyingEmail": "Ihre E-Mail wird verifiziert...",
  "verifyEmailSuccess": "Ihre E-Mail-Adresse wurde erfolgreich verifiziert!",
  "verifyEmailFailed": "Der Verifizierungslink ist ungültig oder abgelaufen.",
  "emailNotVerified": "Ihre E-Mail-Adresse wurde noch nicht verifiziert. Bitte überprüfen Sie Ihren Posteingang.",
  "backToLogin": "Zurück zur Anmeldeseite",
  "verifyEmailCheckSpam": "Keine E-Mail erhalten? Überprüfen Sie Ihren Spam-Ordner.",
  "forgotPassword": "Passwort vergessen?",
  "forgotPasswordTitle": "Passwort zurücksetzen",
  "forgotPasswordBody": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  "sendResetLink": "Zurücksetzen-Link senden",
  "resetSentBody": "Wenn die E-Mail registriert ist, haben wir einen Reset-Link an {{email}} gesendet.",
  "newPassword": "Neues Passwort",
  "confirmPassword": "Passwort bestätigen",
  "passwordMismatch": "Passwörter stimmen nicht überein",
  "passwordMinLen": "Das Passwort muss mindestens 6 Zeichen lang sein",
  "updatePassword": "Passwort aktualisieren",
  "resetPasswordSuccess": "Passwort erfolgreich aktualisiert!",
  "resetPasswordFailed": "Der Reset-Link ist ungültig oder abgelaufen.",
  "changePassword": "Passwort ändern",
  "currentPassword": "Aktuelles Passwort",
  "changePasswordSuccess": "Passwort erfolgreich geändert",
  "currentPasswordWrong": "Das aktuelle Passwort ist falsch",
  "avatarUpdated": "Profilbild aktualisiert",
  "avatarFailed": "Foto hochladen fehlgeschlagen",
  "removePhoto": "Foto löschen",
  "photoRemoved": "Profilfoto gelöscht",
  "cropTitle": "Foto zuschneiden",
  "cancel": "Abbrechen",
  "zoomLabel": "Vergrößern",
  "dragHint": "Foto ziehen, um die Position anzupassen",
  "faqTitle": "Fragen und Antworten",
  "faqSub": "Allgemeine Fragen zur Hajj- und Umrah-Andacht",
  "healthTitle": "Gesundheitstipps",
  "healthSub": "Bewahren Sie Ihre Ausdauer und Gesundheit während der Anbetung",
  "prepTitle": "Vorbereitung",
  "prepSub": "Vorbereitungsmaterial vor der Abreise",
  "noContentYet": "Inhalte werden in Kürze verfügbar sein."
 },
 "es": {
  "appName": "Manasik",
  "tagline": "La Guía Más Completa de Umrah y Hajj",
  "home": "Inicio",
  "guide": "Manasik",
  "prayers": "Oración",
  "map": "Mapa",
  "profile": "Perfil",
  "login": "Entrar",
  "register": "Registrarse",
  "email": "Correo electrónico",
  "password": "Contraseña",
  "name": "Nombre Completo",
  "logout": "Salir",
  "loginTitle": "Bienvenido de Nuevo",
  "registerTitle": "Crear cuenta",
  "noAccount": "¿No tienes una cuenta?",
  "haveAccount": "¿Ya tienes una cuenta?",
  "greeting": "Assalamu'alaikum",
  "journeyProgress": "Progreso del Viaje",
  "startGuide": "Comenzar Manasik",
  "viewPrayers": "Ver Súplica",
  "quickChecklist": "Lista de Preparación",
  "costCalculator": "Calculadora de costos",
  "umrah": "Umra",
  "hajj": "Hajj",
  "steps": "Etapas",
  "markComplete": "Marcar como completado",
  "completed": "Listo",
  "historicalContext": "La Historia de la Biografía Profética",
  "watchGuide": "Guía Visual",
  "arabic": "Árabe",
  "transliteration": "Latín",
  "playAudio": "Reproducir audio",
  "source": "Fuente",
  "allPrayers": "Todas las Oraciones",
  "mapTitle": "Mapa de Lugares Sagrados",
  "mapSubtitle": "Explora los lugares nobles de los manasik",
  "tripType": "Tipo de Adoración",
  "tripDate": "Fecha de Salida",
  "save": "Guardar",
  "saved": "Guardado",
  "completedSteps": "Etapa Completada",
  "account": "Cuenta",
  "loading": "Cargando...",
  "budget": "Presupuesto (por día)",
  "days": "Número de Días",
  "totalCost": "Costo Total Estimado",
  "daysRemaining": "días restantes",
  "calcHint": "Calcule el costo estimado de su viaje",
  "complete": "Listo",
  "welcomeSub": "Comience su viaje espiritual con una guía completa.",
  "qari": "Voz del Recitador",
  "qariHint": "Audio favorito guardado en la cuenta y sincronizado en todos los dispositivos",
  "favoriteSaved": "Recitadores favoritos guardados",
  "preview": "Escucha el ejemplo",
  "previewUnavailable": "El audio de muestra aún no está disponible",
  "searchPrayers": "Buscar oraciones (título, latín, traducción)...",
  "noResults": "No se encontró ninguna oración adecuada",
  "favorites": "Favoritos",
  "addFavorite": "Marcar como favorito",
  "tasbih": "Tasbih Digital",
  "tasbihHint": "Toca el círculo para hacer dhikr · vibración activa",
  "rounds": "Vueltas",
  "download": "Descargar audio",
  "downloaded": "Audio guardado para escuchar sin señal",
  "downloadFailed": "Error al guardar el audio",
  "saveOffline": "Guardar para uso sin conexión",
  "savedOffline": "Guardado sin conexión",
  "removedOffline": "Audio sin conexión eliminado",
  "videoGuides": "Video Guía",
  "videoGuidesHint": "Mira el procedimiento de Umrah y Hajj paso a paso",
  "videoDisclaimer": "Este video es contenido público de terceros (YouTube) y sus derechos de autor pertenecen a sus respectivos propietarios.",
  "quranTitle": "Al-Qur'an & Tafsir",
  "quranHint": "Lee 114 suras con traducción, audio y tafsir Kemenag",
  "times": "Horarios de Oración",
  "qibla": "Dirección de la Qibla",
  "nextPrayer": "Próxima Oración",
  "locating": "Detectando ubicación...",
  "relocate": "Actualizar ubicación",
  "qiblaHint": "La aguja apunta hacia la Ka'bah desde su ubicación",
  "fromNorth": "desde la dirección Norte",
  "enableCompass": "Activar Brújula",
  "compassActive": "Brújula activa — apunte su teléfono horizontalmente",
  "calcMethod": "Método de Cálculo",
  "reminders": "Recordatorio del Adhan",
  "remindersHint": "Un suave recordatorio antes & durante los tiempos de oración",
  "minutesBefore": "minutos antes",
  "remindersEnabled": "El recordatorio del adhan ha sido activado",
  "remindersInApp": "Notificaciones del dispositivo denegadas — los recordatorios seguirán apareciendo dentro de la aplicación",
  "remindersBackground": "Recordatorio de fondo activo — permanece visible aunque la aplicación esté cerrada",
  "adhanSound": "El Sonido del Adhan",
  "adhanSoundHint": "Adhan auténtico de la Masjidil Haram de La Meca, se reproduce automáticamente al entrar los tiempos de oración (aplicación abierta)",
  "adhanPreview": "Probar el Azan",
  "adhanPreviewFajr": "Probar el Adhan del Fajr",
  "adhanStop": "Detener",
  "adhanPlaying": "Llamando ahora…",
  "notifSoonTitle": "Antes de {{prayer}}",
  "notifSoonBody": "{{min}} minutos para el tiempo de {{prayer}}",
  "notifNowTitle": "Hora de {{prayer}}",
  "notifNowBody": "Ha llegado el tiempo de la oración {{prayer}}. Preparémonos para la oración.",
  "packages": "Paquete",
  "verifyEmailSentTitle": "Revise su correo electrónico",
  "verifyEmailSentBody": "Hemos enviado un enlace de verificación a {{email}}. Haz clic en el enlace para activar tu cuenta.",
  "verifyEmailResend": "Reenviar correo electrónico de verificación",
  "verifyEmailResent": "El correo electrónico de verificación ha sido reenviado",
  "verifyingEmail": "Verificando tu correo electrónico...",
  "verifyEmailSuccess": "¡Su correo electrónico ha sido verificado exitosamente!",
  "verifyEmailFailed": "El enlace de verificación no es válido o ha caducado.",
  "emailNotVerified": "Su correo electrónico no ha sido verificado. Por favor, revise su bandeja de entrada.",
  "backToLogin": "Volver a la página de inicio de sesión",
  "verifyEmailCheckSpam": "¿No recibiste el correo electrónico? Revisa tu carpeta de spam.",
  "forgotPassword": "¿Olvidaste tu contraseña?",
  "forgotPasswordTitle": "Restablecer contraseña",
  "forgotPasswordBody": "Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña.",
  "sendResetLink": "Enviar enlace de restablecimiento",
  "resetSentBody": "Si el correo electrónico está registrado, hemos enviado un enlace de restablecimiento a {{email}}.",
  "newPassword": "Nueva contraseña",
  "confirmPassword": "Confirmar contraseña",
  "passwordMismatch": "Las contraseñas no coinciden",
  "passwordMinLen": "La contraseña debe tener al menos 6 caracteres",
  "updatePassword": "Actualizar contraseña",
  "resetPasswordSuccess": "¡Contraseña actualizada correctamente!",
  "resetPasswordFailed": "El enlace de restablecimiento no es válido o ha expirado.",
  "changePassword": "Cambiar contraseña",
  "currentPassword": "Contraseña actual",
  "changePasswordSuccess": "Contraseña cambiada exitosamente",
  "currentPasswordWrong": "La contraseña actual es incorrecta",
  "avatarUpdated": "Foto de perfil actualizada",
  "avatarFailed": "Error al subir la foto",
  "removePhoto": "Eliminar foto",
  "photoRemoved": "Foto de perfil eliminada",
  "cropTitle": "Recortar foto",
  "cancel": "Cancelar",
  "zoomLabel": "Ampliar",
  "dragHint": "Arrastra la foto para ajustar la posición",
  "faqTitle": "Preguntas y Respuestas",
  "faqSub": "Preguntas generales sobre el culto del Hajj y la Umrah",
  "healthTitle": "Consejos de Salud",
  "healthSub": "Mantén tu resistencia y salud durante el culto",
  "prepTitle": "Preparación",
  "prepSub": "Material de preparación antes de la partida",
  "noContentYet": "El contenido estará disponible pronto."
 },
 "ru": {
  "appName": "Манасик",
  "tagline": "Наиболее полное руководство по Умре и Хаджу",
  "home": "Главная",
  "guide": "Манасик",
  "prayers": "Молитва",
  "map": "Карта",
  "profile": "Профиль",
  "login": "Войти",
  "register": "Регистрация",
  "email": "Электронная почта",
  "password": "Пароль",
  "name": "Полное имя",
  "logout": "Выход",
  "loginTitle": "Добро пожаловать обратно",
  "registerTitle": "Создать аккаунт",
  "noAccount": "Нет аккаунта?",
  "haveAccount": "Уже есть аккаунт?",
  "greeting": "Ассаламу'алейкум",
  "journeyProgress": "Прогресс Путешествия",
  "startGuide": "Начать Манасик",
  "viewPrayers": "Просмотр Молитвы",
  "quickChecklist": "Список Подготовки",
  "costCalculator": "Калькулятор стоимости",
  "umrah": "Умра",
  "hajj": "Хадж",
  "steps": "Этапы",
  "markComplete": "Отметить как выполненное",
  "completed": "Готово",
  "historicalContext": "История Пророческого Жизнеописания",
  "watchGuide": "Визуальное руководство",
  "arabic": "Арабы",
  "transliteration": "Латинский",
  "playAudio": "Воспроизвести аудио",
  "source": "Источник",
  "allPrayers": "Все Молитвы",
  "mapTitle": "Карта Священных Мест",
  "mapSubtitle": "Исследуйте благородные места манасик",
  "tripType": "Вид Поклонения",
  "tripDate": "Дата Отправления",
  "save": "Сохранить",
  "saved": "Сохранено",
  "completedSteps": "Этап Завершён",
  "account": "Аккаунт",
  "loading": "Загрузка...",
  "budget": "Бюджет (в день)",
  "days": "Количество Дней",
  "totalCost": "Приблизительная Общая Стоимость",
  "daysRemaining": "дней осталось",
  "calcHint": "Рассчитайте приблизительную стоимость вашей поездки",
  "complete": "Готово",
  "welcomeSub": "Начните своё духовное путешествие с полным руководством.",
  "qari": "Голос Чтеца",
  "qariHint": "Избранное аудио сохранено в аккаунте и синхронизировано на всех устройствах",
  "favoriteSaved": "Избранные чтецы сохранены",
  "preview": "Послушайте пример",
  "previewUnavailable": "Пример аудио пока недоступен",
  "searchPrayers": "Поиск молитв (название, латиница, перевод)...",
  "noResults": "Подходящая молитва не найдена",
  "favorites": "Избранное",
  "addFavorite": "Отметить как избранное",
  "tasbih": "Цифровой Тасбих",
  "tasbihHint": "Нажмите на круг для зикра · вибрация активна",
  "rounds": "Круги",
  "download": "Скачать аудио",
  "downloaded": "Аудио сохранено для прослушивания без сигнала",
  "downloadFailed": "Не удалось сохранить аудио",
  "saveOffline": "Сохранить для офлайн-использования",
  "savedOffline": "Сохранено офлайн",
  "removedOffline": "Офлайн-аудио удалено",
  "videoGuides": "Обучающее видео",
  "videoGuidesHint": "Смотрите пошаговое руководство по процедурам Умры и Хаджа",
  "videoDisclaimer": "Это видео является общедоступным контентом третьих лиц (YouTube), и авторские права принадлежат соответствующим владельцам.",
  "quranTitle": "Аль-Коран и Тафсир",
  "quranHint": "Читайте 114 сур с переводом, аудио и тафсиром Кеменаг",
  "times": "Время Намаза",
  "qibla": "Направление Киблы",
  "nextPrayer": "Следующая Молитва",
  "locating": "Определение местоположения...",
  "relocate": "Обновить местоположение",
  "qiblaHint": "Стрелка указывает направление на Каабу из вашего местоположения",
  "fromNorth": "с северного направления",
  "enableCompass": "Включить Компас",
  "compassActive": "Компас активен — держите телефон горизонтально",
  "calcMethod": "Метод Расчёта",
  "reminders": "Напоминание об Азане",
  "remindersHint": "Мягкое напоминание перед & во время времён намаза",
  "minutesBefore": "минут до",
  "remindersEnabled": "Напоминание об азане активировано",
  "remindersInApp": "Уведомления устройства отклонены — напоминания по-прежнему будут отображаться в приложении",
  "remindersBackground": "Активное фоновое напоминание — остаётся видимым даже при закрытом приложении",
  "adhanSound": "Звук Азана",
  "adhanSoundHint": "Подлинный азан из Масджид аль-Харам Мекки, автоматически воспроизводится при наступлении времени молитвы (приложение открыто)",
  "adhanPreview": "Попробовать Азан",
  "adhanPreviewFajr": "Попробовать азан Фаджр",
  "adhanStop": "Стоп",
  "adhanPlaying": "Идёт призыв…",
  "notifSoonTitle": "Перед {{prayer}}",
  "notifSoonBody": "{{min}} минут до времени {{prayer}}",
  "notifNowTitle": "Время {{prayer}}",
  "notifNowBody": "Наступило время молитвы {{prayer}}. Давайте подготовимся к намазу.",
  "packages": "Пакет",
  "verifyEmailSentTitle": "Проверьте вашу электронную почту",
  "verifyEmailSentBody": "Мы отправили ссылку для подтверждения на {{email}}. Нажмите на ссылку, чтобы активировать вашу учётную запись.",
  "verifyEmailResend": "Повторно отправить письмо с подтверждением",
  "verifyEmailResent": "Письмо для подтверждения было отправлено повторно",
  "verifyingEmail": "Проверка вашей электронной почты...",
  "verifyEmailSuccess": "Ваш адрес электронной почты успешно подтверждён!",
  "verifyEmailFailed": "Ссылка для подтверждения недействительна или истекла.",
  "emailNotVerified": "Ваш адрес электронной почты не подтверждён. Пожалуйста, проверьте свой почтовый ящик.",
  "backToLogin": "Вернуться на страницу входа",
  "verifyEmailCheckSpam": "Не получили письмо? Проверьте папку со спамом.",
  "forgotPassword": "Забыли пароль?",
  "forgotPasswordTitle": "Сброс пароля",
  "forgotPasswordBody": "Введите ваш адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
  "sendResetLink": "Отправить ссылку для сброса",
  "resetSentBody": "Если электронная почта зарегистрирована, мы отправили ссылку для сброса на {{email}}.",
  "newPassword": "Новый пароль",
  "confirmPassword": "Подтвердите пароль",
  "passwordMismatch": "Пароли не совпадают",
  "passwordMinLen": "Пароль должен содержать не менее 6 символов",
  "updatePassword": "Обновить пароль",
  "resetPasswordSuccess": "Пароль успешно обновлён!",
  "resetPasswordFailed": "Ссылка для сброса недействительна или устарела.",
  "changePassword": "Изменить пароль",
  "currentPassword": "Текущий пароль",
  "changePasswordSuccess": "Пароль успешно изменён",
  "currentPasswordWrong": "Текущий пароль неверен",
  "avatarUpdated": "Фото профиля обновлено",
  "avatarFailed": "Не удалось загрузить фото",
  "removePhoto": "Удалить фото",
  "photoRemoved": "Фото профиля удалено",
  "cropTitle": "Обрезать фото",
  "cancel": "Отмена",
  "zoomLabel": "Увеличить",
  "dragHint": "Перетащите фото, чтобы настроить положение",
  "faqTitle": "Вопросы и Ответы",
  "faqSub": "Общие вопросы об обрядах Хаджа и Умры",
  "healthTitle": "Советы по здоровью",
  "healthSub": "Сохраняйте силы и здоровье во время поклонения",
  "prepTitle": "Подготовка",
  "prepSub": "Материалы подготовки перед отъездом",
  "noContentYet": "Контент скоро появится."
 },
 "zh": {
  "appName": "朝觐礼仪",
  "tagline": "最完整的副朝与朝觐指南",
  "home": "首页",
  "guide": "朝觐礼仪",
  "prayers": "祈祷",
  "map": "地图",
  "profile": "个人资料",
  "login": "进入",
  "register": "注册",
  "email": "电子邮件",
  "password": "密码",
  "name": "全名",
  "logout": "退出",
  "loginTitle": "欢迎回来",
  "registerTitle": "创建账户",
  "noAccount": "还没有账户？",
  "haveAccount": "已有账号？",
  "greeting": "愿你们平安",
  "journeyProgress": "旅程进展",
  "startGuide": "开始朝觐仪式",
  "viewPrayers": "查看祈祷",
  "quickChecklist": "准备清单",
  "costCalculator": "费用计算器",
  "umrah": "副朝",
  "hajj": "朝觐",
  "steps": "阶段",
  "markComplete": "标记为完成",
  "completed": "完成",
  "historicalContext": "先知传记故事",
  "watchGuide": "视觉指南",
  "arabic": "阿拉伯人",
  "transliteration": "拉丁语",
  "playAudio": "播放音频",
  "source": "来源",
  "allPrayers": "所有祈祷",
  "mapTitle": "圣地地图",
  "mapSubtitle": "探索朝觉圣地",
  "tripType": "礼拜类型",
  "tripDate": "出发日期",
  "save": "保存",
  "saved": "已保存",
  "completedSteps": "阶段完成",
  "account": "账户",
  "loading": "加载中...",
  "budget": "预算（每天）",
  "days": "天数",
  "totalCost": "预计总费用",
  "daysRemaining": "剩余天数",
  "calcHint": "计算您的预估旅行费用",
  "complete": "完成",
  "welcomeSub": "以完整的指南开始您的精神之旅。",
  "qari": "诵读者的声音",
  "qariHint": "收藏的音频已保存至账户并同步到所有设备",
  "favoriteSaved": "已保存喜爱的诵读者",
  "preview": "听示例",
  "previewUnavailable": "示例音频尚未提供",
  "searchPrayers": "搜索祈祷文（标题、拉丁文、翻译）...",
  "noResults": "没有找到合适的祈祷",
  "favorites": "收藏夹",
  "addFavorite": "标记为收藏",
  "tasbih": "数字念珠",
  "tasbihHint": "点击圆圈进行念珠 · 振动已开启",
  "rounds": "圈数",
  "download": "下载音频",
  "downloaded": "音频已保存，可在无信号时收听",
  "downloadFailed": "保存音频失败",
  "saveOffline": "保存以供离线使用",
  "savedOffline": "已离线保存",
  "removedOffline": "离线音频已删除",
  "videoGuides": "指导视频",
  "videoGuidesHint": "逐步观看麦加朝圣小朝（乌姆拉）与大朝（哈吉）的程序指南",
  "videoDisclaimer": "本视频为第三方公开内容（YouTube），其版权归各自所有者所有。",
  "quranTitle": "《古兰经》与注释",
  "quranHint": "阅读114章苏拉，附翻译、音频和Kemenag塔菲尔",
  "times": "礼拜时间",
  "qibla": "朝拜方向",
  "nextPrayer": "下一次祈祷",
  "locating": "正在检测位置...",
  "relocate": "更新位置",
  "qiblaHint": "指针从您的位置指向克尔白方向",
  "fromNorth": "从北方方向",
  "enableCompass": "启用指南针",
  "compassActive": "指南针已启动 — 请将手机水平放置",
  "calcMethod": "计算方法",
  "reminders": "礼拜呼唤提醒",
  "remindersHint": "在礼拜时间前后的温馨提醒",
  "minutesBefore": "分钟前",
  "remindersEnabled": "宣礼提醒已启用",
  "remindersInApp": "设备通知已被拒绝 — 提醒仍将在应用内显示",
  "remindersBackground": "活跃后台提醒 — 即使应用关闭后仍保持显示",
  "adhanSound": "呼礼声",
  "adhanSoundHint": "来自麦加麦斯吉德·禁寺的正宗宣礼，在礼拜时间到来时自动播放（应用程序已开启）",
  "adhanPreview": "试听阿赞",
  "adhanPreviewFajr": "试听晨礼唤礼词",
  "adhanStop": "停止",
  "adhanPlaying": "正在呼唤…",
  "notifSoonTitle": "{{prayer}}前",
  "notifSoonBody": "距{{prayer}}时间还有{{min}}分钟",
  "notifNowTitle": "{{prayer}}时间",
  "notifNowBody": "{{prayer}}的礼拜时间已到。让我们准备礼拜。",
  "packages": "套餐",
  "verifyEmailSentTitle": "请检查您的电子邮件",
  "verifyEmailSentBody": "我们已将验证链接发送至 {{email}}。请点击该链接以激活您的账户。",
  "verifyEmailResend": "重新发送验证邮件",
  "verifyEmailResent": "验证邮件已重新发送",
  "verifyingEmail": "正在验证您的电子邮件...",
  "verifyEmailSuccess": "您的电子邮件已成功验证！",
  "verifyEmailFailed": "验证链接无效或已过期。",
  "emailNotVerified": "您的电子邮件尚未验证。请检查您的收件箱。",
  "backToLogin": "返回登录页面",
  "verifyEmailCheckSpam": "没有收到电子邮件？请检查您的垃圾邮件文件夹。",
  "forgotPassword": "忘记密码？",
  "forgotPasswordTitle": "重置密码",
  "forgotPasswordBody": "输入您的电子邮件，我们将向您发送一个重置密码的链接。",
  "sendResetLink": "发送重置链接",
  "resetSentBody": "如果该电子邮件已注册，我们已将重置链接发送至 {{email}}。",
  "newPassword": "新密码",
  "confirmPassword": "确认密码",
  "passwordMismatch": "密码不匹配",
  "passwordMinLen": "密码至少需要6个字符",
  "updatePassword": "更新密码",
  "resetPasswordSuccess": "密码更新成功！",
  "resetPasswordFailed": "重置链接无效或已过期。",
  "changePassword": "更改密码",
  "currentPassword": "当前密码",
  "changePasswordSuccess": "密码已成功更改",
  "currentPasswordWrong": "当前密码不正确",
  "avatarUpdated": "头像已更新",
  "avatarFailed": "照片上传失败",
  "removePhoto": "删除照片",
  "photoRemoved": "个人资料照片已删除",
  "cropTitle": "裁剪照片",
  "cancel": "取消",
  "zoomLabel": "放大",
  "dragHint": "拖动照片以调整位置",
  "faqTitle": "问答",
  "faqSub": "关于朝觐与副朝功课的常见问题",
  "healthTitle": "健康小贴士",
  "healthSub": "在礼拜期间保持体力与健康",
  "prepTitle": "准备",
  "prepSub": "出发前的准备材料",
  "noContentYet": "内容即将推出。"
 },
 "ja": {
  "appName": "マナーシク",
  "tagline": "最も完全なウムラとハッジのガイド",
  "home": "ホーム",
  "guide": "マナースィク",
  "prayers": "祈り",
  "map": "地図",
  "profile": "プロフィール",
  "login": "入る",
  "register": "登録",
  "email": "メール",
  "password": "パスワード",
  "name": "フルネーム",
  "logout": "終了",
  "loginTitle": "おかえりなさい",
  "registerTitle": "アカウントを作成",
  "noAccount": "アカウントをお持ちでないですか？",
  "haveAccount": "すでにアカウントをお持ちですか？",
  "greeting": "アッサラーム・アライクム",
  "journeyProgress": "旅の進捗",
  "startGuide": "マナシクを開始する",
  "viewPrayers": "祈りを見る",
  "quickChecklist": "準備リスト",
  "costCalculator": "費用計算ツール",
  "umrah": "ウムラ",
  "hajj": "ハッジ",
  "steps": "段階",
  "markComplete": "完了としてマーク",
  "completed": "完了",
  "historicalContext": "預言者伝記の物語",
  "watchGuide": "ビジュアルガイド",
  "arabic": "アラブ人",
  "transliteration": "ラテン語",
  "playAudio": "オーディオを再生",
  "source": "出典",
  "allPrayers": "すべての祈り",
  "mapTitle": "聖地マップ",
  "mapSubtitle": "マナシクの崇高な場所を探索する",
  "tripType": "礼拝の種類",
  "tripDate": "出発日",
  "save": "保存",
  "saved": "保存済み",
  "completedSteps": "ステージ完了",
  "account": "アカウント",
  "loading": "読み込み中...",
  "budget": "予算（1日あたり）",
  "days": "日数",
  "totalCost": "推定総費用",
  "daysRemaining": "残り日数",
  "calcHint": "旅行の推定費用を計算する",
  "complete": "完了",
  "welcomeSub": "完全なガイドであなたの精神的な旅を始めましょう。",
  "qari": "朗読者の声",
  "qariHint": "お気に入りの音声がアカウントに保存され、すべてのデバイスに同期されます",
  "favoriteSaved": "お気に入りの朗読者が保存されました",
  "preview": "例を聞いてください",
  "previewUnavailable": "サンプル音声はまだ利用できません",
  "searchPrayers": "祈りを検索する（タイトル、ラテン文字、翻訳）...",
  "noResults": "適切な祈りが見つかりません",
  "favorites": "お気に入り",
  "addFavorite": "お気に入りに追加",
  "tasbih": "デジタルタスビーフ",
  "tasbihHint": "円をタップしてズィクルを行う · バイブレーション有効",
  "rounds": "周回",
  "download": "オーディオをダウンロード",
  "downloaded": "信号なしで聴けるように音声を保存しました",
  "downloadFailed": "音声の保存に失敗しました",
  "saveOffline": "オフライン用に保存",
  "savedOffline": "オフラインで保存済み",
  "removedOffline": "オフラインオーディオが削除されました",
  "videoGuides": "ガイド動画",
  "videoGuidesHint": "ウムラとハッジの手順をステップバイステップで動画でご覧ください",
  "videoDisclaimer": "この動画はサードパーティの公開コンテンツ（YouTube）であり、著作権はそれぞれの所有者に帰属します。",
  "quranTitle": "クルアーン＆タフスィール",
  "quranHint": "翻訳・音声・Kemenagタフシール付きで114のスーラを読む",
  "times": "礼拝時間",
  "qibla": "キブラの方向",
  "nextPrayer": "次の礼拝",
  "locating": "位置情報を検出中...",
  "relocate": "位置情報を更新する",
  "qiblaHint": "針はあなたの現在地からカアバの方向を指しています",
  "fromNorth": "北の方角から",
  "enableCompass": "コンパスを有効にする",
  "compassActive": "コンパス起動中 — スマートフォンを水平に向けてください",
  "calcMethod": "計算方法",
  "reminders": "アザーンリマインダー",
  "remindersHint": "礼拝の時間の前後に優しくお知らせします",
  "minutesBefore": "分前",
  "remindersEnabled": "アザーンのリマインダーが有効になりました",
  "remindersInApp": "デバイス通知が拒否されました — リマインダーはアプリ内に引き続き表示されます",
  "remindersBackground": "アクティブなバックグラウンドリマインダー — アプリを閉じても表示され続けます",
  "adhanSound": "アザーンの音",
  "adhanSoundHint": "マッカのマスジド・ハラームからの本物のアザーン、礼拝時間になると自動的に再生されます（アプリ起動中）",
  "adhanPreview": "アザーンを試す",
  "adhanPreviewFajr": "ファジュルのアザーンを試す",
  "adhanStop": "停止",
  "adhanPlaying": "呼びかけ中…",
  "notifSoonTitle": "{{prayer}}の前に",
  "notifSoonBody": "{{prayer}}の時間まであと{{min}}分",
  "notifNowTitle": "{{prayer}}の時間",
  "notifNowBody": "{{prayer}}の礼拝の時間になりました。礼拝の準備をしましょう。",
  "packages": "パッケージ",
  "verifyEmailSentTitle": "メールをご確認ください",
  "verifyEmailSentBody": "{{email}} に確認リンクを送信しました。リンクをクリックしてアカウントを有効にしてください。",
  "verifyEmailResend": "確認メールを再送する",
  "verifyEmailResent": "確認メールが再送信されました",
  "verifyingEmail": "メールアドレスを確認しています...",
  "verifyEmailSuccess": "メールアドレスの確認が完了しました！",
  "verifyEmailFailed": "確認リンクが無効または期限切れです。",
  "emailNotVerified": "メールアドレスがまだ確認されていません。受信トレイをご確認ください。",
  "backToLogin": "ログインページに戻る",
  "verifyEmailCheckSpam": "メールが届きませんでしたか？迷惑メールフォルダをご確認ください。",
  "forgotPassword": "パスワードをお忘れですか？",
  "forgotPasswordTitle": "パスワードをリセット",
  "forgotPasswordBody": "メールアドレスを入力してください。パスワードをリセットするためのリンクをお送りします。",
  "sendResetLink": "リセットリンクを送信する",
  "resetSentBody": "登録済みのメールアドレスが存在する場合、{{email}} にリセットリンクを送信しました。",
  "newPassword": "新しいパスワード",
  "confirmPassword": "パスワードの確認",
  "passwordMismatch": "パスワードが一致しません",
  "passwordMinLen": "パスワードは6文字以上必要です",
  "updatePassword": "パスワードを更新する",
  "resetPasswordSuccess": "パスワードが正常に更新されました！",
  "resetPasswordFailed": "リセットリンクが無効または期限切れです。",
  "changePassword": "パスワードを変更する",
  "currentPassword": "現在のパスワード",
  "changePasswordSuccess": "パスワードが正常に変更されました",
  "currentPasswordWrong": "現在のパスワードが正しくありません",
  "avatarUpdated": "プロフィール写真を更新しました",
  "avatarFailed": "写真のアップロードに失敗しました",
  "removePhoto": "写真を削除",
  "photoRemoved": "プロフィール写真が削除されました",
  "cropTitle": "写真をトリミング",
  "cancel": "キャンセル",
  "zoomLabel": "拡大",
  "dragHint": "写真をドラッグして位置を調整する",
  "faqTitle": "質問と回答",
  "faqSub": "ハッジとウムラの礼拝に関するよくある質問",
  "healthTitle": "健康のヒント",
  "healthSub": "礼拝中はスタミナと健康を維持しましょう",
  "prepTitle": "準備",
  "prepSub": "出発前の準備資料",
  "noContentYet": "コンテンツは近日公開予定です。"
 },
 "ko": {
  "appName": "마나식",
  "tagline": "가장 완벽한 우므라 & 하지 가이드",
  "home": "홈",
  "guide": "마나식",
  "prayers": "기도",
  "map": "지도",
  "profile": "프로필",
  "login": "들어가기",
  "register": "등록",
  "email": "이메일",
  "password": "비밀번호",
  "name": "전체 이름",
  "logout": "종료",
  "loginTitle": "다시 오신 것을 환영합니다",
  "registerTitle": "계정 만들기",
  "noAccount": "계정이 없으신가요?",
  "haveAccount": "이미 계정이 있으신가요?",
  "greeting": "앗살라무 알라이쿰",
  "journeyProgress": "여정 진행 상황",
  "startGuide": "마나시크 시작",
  "viewPrayers": "기도 보기",
  "quickChecklist": "준비 목록",
  "costCalculator": "비용 계산기",
  "umrah": "우므라",
  "hajj": "하지",
  "steps": "단계",
  "markComplete": "완료로 표시",
  "completed": "완료",
  "historicalContext": "예언자 전기 이야기",
  "watchGuide": "시각적 가이드",
  "arabic": "아랍인",
  "transliteration": "라틴어",
  "playAudio": "오디오 재생",
  "source": "출처",
  "allPrayers": "모든 기도",
  "mapTitle": "성지 지도",
  "mapSubtitle": "마나식의 성스러운 장소를 탐험하세요",
  "tripType": "예배 유형",
  "tripDate": "출발 날짜",
  "save": "저장",
  "saved": "저장됨",
  "completedSteps": "단계 완료",
  "account": "계정",
  "loading": "로딩 중...",
  "budget": "예산 (하루당)",
  "days": "일 수",
  "totalCost": "예상 총 비용",
  "daysRemaining": "남은 일수",
  "calcHint": "예상 여행 비용을 계산하세요",
  "complete": "완료",
  "welcomeSub": "완전한 가이드와 함께 영적 여정을 시작하세요.",
  "qari": "낭독자의 목소리",
  "qariHint": "즐겨찾기 오디오가 계정에 저장되어 모든 기기에 동기화됩니다",
  "favoriteSaved": "즐겨찾는 낭송자가 저장되었습니다",
  "preview": "예시를 들어보세요",
  "previewUnavailable": "샘플 오디오는 아직 제공되지 않습니다",
  "searchPrayers": "기도 검색 (제목, 라틴어, 번역)...",
  "noResults": "적합한 기도가 없습니다",
  "favorites": "즐겨찾기",
  "addFavorite": "즐겨찾기로 표시",
  "tasbih": "디지털 타스비흐",
  "tasbihHint": "원을 탭하여 지크르 하기 · 진동 활성화",
  "rounds": "바퀴",
  "download": "오디오 다운로드",
  "downloaded": "신호 없이 들을 수 있도록 오디오가 저장되었습니다",
  "downloadFailed": "오디오 저장 실패",
  "saveOffline": "오프라인용으로 저장",
  "savedOffline": "오프라인으로 저장됨",
  "removedOffline": "오프라인 오디오가 삭제되었습니다",
  "videoGuides": "가이드 동영상",
  "videoGuidesHint": "우므라 및 하지 절차를 단계별로 시청하세요",
  "videoDisclaimer": "이 동영상은 제3자 공개 콘텐츠(YouTube)이며 저작권은 각 소유자에게 있습니다.",
  "quranTitle": "꾸란 & 타프시르",
  "quranHint": "번역, 오디오 및 Kemenag 타프시르와 함께 114개의 수라 읽기",
  "times": "기도 시간",
  "qibla": "키블라 방향",
  "nextPrayer": "다음 기도",
  "locating": "위치 감지 중...",
  "relocate": "위치 업데이트",
  "qiblaHint": "바늘이 현재 위치에서 카아바 방향을 가리킵니다",
  "fromNorth": "북쪽 방향에서",
  "enableCompass": "나침반 활성화",
  "compassActive": "나침반 활성화 — 스마트폰을 수평으로 향하세요",
  "calcMethod": "계산 방법",
  "reminders": "아잔 알림",
  "remindersHint": "예배 시간 전후의 부드러운 알림",
  "minutesBefore": "분 전",
  "remindersEnabled": "아잔 알림이 활성화되었습니다",
  "remindersInApp": "기기 알림이 거부되었습니다 — 알림은 앱 내에서 계속 표시됩니다",
  "remindersBackground": "활성 백그라운드 알림 — 앱이 닫혀도 계속 표시됩니다",
  "adhanSound": "아잔 소리",
  "adhanSoundHint": "메카 마스지드 알-하람의 정통 아잔으로, 예배 시간이 되면 자동으로 재생됩니다 (앱 실행 중)",
  "adhanPreview": "아잔 시험해보기",
  "adhanPreviewFajr": "파즈르 아잔 듣기",
  "adhanStop": "중지",
  "adhanPlaying": "호출 중…",
  "notifSoonTitle": "{{prayer}} 전에",
  "notifSoonBody": "{{prayer}} 시간까지 {{min}}분 남았습니다",
  "notifNowTitle": "{{prayer}} 시간",
  "notifNowBody": "{{prayer}} 예배 시간이 되었습니다. 예배를 준비합시다.",
  "packages": "패키지",
  "verifyEmailSentTitle": "이메일을 확인하세요",
  "verifyEmailSentBody": "{{email}}로 인증 링크를 보냈습니다. 링크를 클릭하여 계정을 활성화하세요.",
  "verifyEmailResend": "인증 이메일 재전송",
  "verifyEmailResent": "인증 이메일이 재전송되었습니다",
  "verifyingEmail": "이메일을 확인하는 중...",
  "verifyEmailSuccess": "이메일이 성공적으로 인증되었습니다!",
  "verifyEmailFailed": "인증 링크가 유효하지 않거나 만료되었습니다.",
  "emailNotVerified": "이메일이 아직 인증되지 않았습니다. 받은 편지함을 확인해 주세요.",
  "backToLogin": "로그인 페이지로 돌아가기",
  "verifyEmailCheckSpam": "이메일을 받지 못하셨나요? 스팸 폴더를 확인해 주세요.",
  "forgotPassword": "비밀번호를 잊으셨나요?",
  "forgotPasswordTitle": "비밀번호 재설정",
  "forgotPasswordBody": "이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
  "sendResetLink": "재설정 링크 보내기",
  "resetSentBody": "등록된 이메일이 존재하면 {{email}}로 재설정 링크를 보냈습니다.",
  "newPassword": "새 비밀번호",
  "confirmPassword": "비밀번호 확인",
  "passwordMismatch": "비밀번호가 일치하지 않습니다",
  "passwordMinLen": "비밀번호는 최소 6자 이상이어야 합니다",
  "updatePassword": "비밀번호 업데이트",
  "resetPasswordSuccess": "비밀번호가 성공적으로 업데이트되었습니다!",
  "resetPasswordFailed": "재설정 링크가 유효하지 않거나 만료되었습니다.",
  "changePassword": "비밀번호 변경",
  "currentPassword": "현재 비밀번호",
  "changePasswordSuccess": "비밀번호가 성공적으로 변경되었습니다",
  "currentPasswordWrong": "현재 비밀번호가 올바르지 않습니다",
  "avatarUpdated": "프로필 사진이 업데이트되었습니다",
  "avatarFailed": "사진 업로드에 실패했습니다",
  "removePhoto": "사진 삭제",
  "photoRemoved": "프로필 사진이 삭제되었습니다",
  "cropTitle": "사진 자르기",
  "cancel": "취소",
  "zoomLabel": "확대",
  "dragHint": "사진을 드래그하여 위치를 조정하세요",
  "faqTitle": "질문과 답변",
  "faqSub": "하지 및 우므라 예배에 관한 일반적인 질문",
  "healthTitle": "건강 팁",
  "healthSub": "예배 중 체력과 건강을 유지하세요",
  "prepTitle": "준비",
  "prepSub": "출발 전 준비 자료",
  "noContentYet": "콘텐츠가 곧 제공될 예정입니다."
 },
 "hi": {
  "appName": "मनासिक",
  "tagline": "उमरह और हज का सबसे संपूर्ण मार्गदर्शिका",
  "home": "होम",
  "guide": "मनासिक",
  "prayers": "दुआ",
  "map": "नक्शा",
  "profile": "प्रोफ़ाइल",
  "login": "प्रवेश करें",
  "register": "पंजीकरण",
  "email": "ईमेल",
  "password": "पासवर्ड",
  "name": "पूरा नाम",
  "logout": "बाहर निकलें",
  "loginTitle": "वापस स्वागत है",
  "registerTitle": "खाता बनाएं",
  "noAccount": "क्या आपका कोई खाता नहीं है?",
  "haveAccount": "क्या आपके पास पहले से एक खाता है?",
  "greeting": "अस्सलामु अलैकुम",
  "journeyProgress": "यात्रा की प्रगति",
  "startGuide": "मनासिक शुरू करें",
  "viewPrayers": "दुआ देखें",
  "quickChecklist": "तैयारी सूची",
  "costCalculator": "लागत कैलकुलेटर",
  "umrah": "उमराह",
  "hajj": "हज",
  "steps": "चरण",
  "markComplete": "पूर्ण के रूप में चिह्नित करें",
  "completed": "पूर्ण",
  "historicalContext": "सीरत-ए-नबवी की कहानी",
  "watchGuide": "दृश्य मार्गदर्शिका",
  "arabic": "अरब",
  "transliteration": "लैटिन",
  "playAudio": "ऑडियो चलाएं",
  "source": "स्रोत",
  "allPrayers": "सभी दुआएं",
  "mapTitle": "पवित्र स्थलों का नक्शा",
  "mapSubtitle": "मनासिक के पवित्र स्थानों का अन्वेषण करें",
  "tripType": "इबादत का प्रकार",
  "tripDate": "प्रस्थान तिथि",
  "save": "सहेजें",
  "saved": "सहेजा गया",
  "completedSteps": "चरण पूर्ण",
  "account": "खाता",
  "loading": "लोड हो रहा है...",
  "budget": "बजट (प्रति दिन)",
  "days": "दिनों की संख्या",
  "totalCost": "अनुमानित कुल लागत",
  "daysRemaining": "दिन शेष",
  "calcHint": "अपनी अनुमानित यात्रा लागत की गणना करें",
  "complete": "पूर्ण",
  "welcomeSub": "एक संपूर्ण मार्गदर्शिका के साथ अपनी आध्यात्मिक यात्रा शुरू करें।",
  "qari": "पाठक की आवाज़",
  "qariHint": "पसंदीदा ऑडियो खाते में सहेजा गया और सभी उपकरणों में सिंक किया गया",
  "favoriteSaved": "पसंदीदा क़ारी सहेजे गए",
  "preview": "उदाहरण सुनें",
  "previewUnavailable": "नमूना ऑडियो अभी उपलब्ध नहीं है",
  "searchPrayers": "दुआ खोजें (शीर्षक, लैटिन, अनुवाद)...",
  "noResults": "कोई उपयुक्त दुआ नहीं मिली",
  "favorites": "पसंदीदा",
  "addFavorite": "पसंदीदा के रूप में चिह्नित करें",
  "tasbih": "डिजिटल तस्बीह",
  "tasbihHint": "धिक्र के लिए वृत्त को टैप करें · कंपन सक्रिय",
  "rounds": "चक्कर",
  "download": "ऑडियो डाउनलोड करें",
  "downloaded": "ऑडियो बिना सिग्नल के सुनने के लिए सहेजा गया",
  "downloadFailed": "ऑडियो सहेजने में विफल",
  "saveOffline": "ऑफलाइन के लिए सहेजें",
  "savedOffline": "ऑफ़लाइन सहेजा गया",
  "removedOffline": "ऑफलाइन ऑडियो हटा दिया गया",
  "videoGuides": "गाइड वीडियो",
  "videoGuidesHint": "उमराह और हज की प्रक्रिया को चरण दर चरण देखें",
  "videoDisclaimer": "यह वीडियो तृतीय-पक्ष सार्वजनिक सामग्री (YouTube) है और इसका कॉपीराइट संबंधित स्वामियों का है।",
  "quranTitle": "अल-क़ुरआन और तफ़सीर",
  "quranHint": "अनुवाद, ऑडियो और Kemenag तफ़सीर के साथ 114 सूरह पढ़ें",
  "times": "नमाज़ का वक्त",
  "qibla": "क़िब्ला दिशा",
  "nextPrayer": "अगली नमाज़",
  "locating": "स्थान का पता लगाया जा रहा है...",
  "relocate": "स्थान अपडेट करें",
  "qiblaHint": "सुई आपके स्थान से काबा की दिशा दर्शाती है",
  "fromNorth": "उत्तर दिशा से",
  "enableCompass": "कम्पास सक्रिय करें",
  "compassActive": "कम्पास सक्रिय है — अपना फ़ोन क्षैतिज रखें",
  "calcMethod": "गणना विधि",
  "reminders": "अज़ान रिमाइंडर",
  "remindersHint": "नमाज़ के वक्त से पहले & दौरान एक सौम्य अनुस्मारक",
  "minutesBefore": "मिनट पहले",
  "remindersEnabled": "अज़ान रिमाइंडर सक्रिय कर दिया गया है",
  "remindersInApp": "डिवाइस सूचनाएं अस्वीकृत — रिमाइंडर ऐप के अंदर दिखते रहेंगे",
  "remindersBackground": "सक्रिय बैकग्राउंड रिमाइंडर — ऐप बंद होने पर भी दिखता रहता है",
  "adhanSound": "अज़ान की आवाज़",
  "adhanSoundHint": "मक्का की मस्जिद अल-हराम से प्रामाणिक अज़ान, नमाज़ के वक्त पर स्वचालित रूप से बजती है (ऐप खुला होने पर)",
  "adhanPreview": "अज़ान आज़माएं",
  "adhanPreviewFajr": "फ़ज्र की अज़ान आज़माएं",
  "adhanStop": "रुकें",
  "adhanPlaying": "अभी पुकारा जा रहा है…",
  "notifSoonTitle": "{{prayer}} से पहले",
  "notifSoonBody": "{{prayer}} के समय तक {{min}} मिनट बाकी हैं",
  "notifNowTitle": "{{prayer}} का समय",
  "notifNowBody": "{{prayer}} की नमाज़ का वक्त हो गया है। नमाज़ के लिए तैयार हो जाइए।",
  "packages": "पैकेज",
  "verifyEmailSentTitle": "अपना ईमेल जांचें",
  "verifyEmailSentBody": "हमने {{email}} पर एक सत्यापन लिंक भेजा है। अपना खाता सक्रिय करने के लिए उस लिंक पर क्लिक करें।",
  "verifyEmailResend": "सत्यापन ईमेल पुनः भेजें",
  "verifyEmailResent": "सत्यापन ईमेल पुनः भेजा गया है",
  "verifyingEmail": "आपका ईमेल सत्यापित किया जा रहा है...",
  "verifyEmailSuccess": "आपका ईमेल सफलतापूर्वक सत्यापित हो गया है!",
  "verifyEmailFailed": "सत्यापन लिंक अमान्य है या समाप्त हो गया है।",
  "emailNotVerified": "आपका ईमेल सत्यापित नहीं हुआ है। कृपया अपना इनबॉक्स जाँचें।",
  "backToLogin": "साइन इन पृष्ठ पर वापस जाएं",
  "verifyEmailCheckSpam": "ईमेल प्राप्त नहीं हुआ? अपना स्पैम फ़ोल्डर जांचें।",
  "forgotPassword": "क्या आप अपना पासवर्ड भूल गए?",
  "forgotPasswordTitle": "पासवर्ड रीसेट करें",
  "forgotPasswordBody": "अपना ईमेल दर्ज करें और हम आपको पासवर्ड रीसेट करने के लिए एक लिंक भेजेंगे।",
  "sendResetLink": "रीसेट लिंक भेजें",
  "resetSentBody": "यदि ईमेल पंजीकृत है, तो हमने {{email}} पर एक रीसेट लिंक भेजा है।",
  "newPassword": "नया पासवर्ड",
  "confirmPassword": "पासवर्ड की पुष्टि करें",
  "passwordMismatch": "पासवर्ड मेल नहीं खाते",
  "passwordMinLen": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
  "updatePassword": "पासवर्ड अपडेट करें",
  "resetPasswordSuccess": "पासवर्ड सफलतापूर्वक अपडेट किया गया!",
  "resetPasswordFailed": "रीसेट लिंक अमान्य है या समाप्त हो गया है।",
  "changePassword": "पासवर्ड बदलें",
  "currentPassword": "वर्तमान पासवर्ड",
  "changePasswordSuccess": "पासवर्ड सफलतापूर्वक बदल दिया गया",
  "currentPasswordWrong": "वर्तमान पासवर्ड गलत है",
  "avatarUpdated": "प्रोफ़ाइल फ़ोटो अपडेट किया गया",
  "avatarFailed": "फ़ोटो अपलोड करने में विफल",
  "removePhoto": "फ़ोटो हटाएं",
  "photoRemoved": "प्रोफ़ाइल फ़ोटो हटा दी गई",
  "cropTitle": "फ़ोटो क्रॉप करें",
  "cancel": "रद्द करें",
  "zoomLabel": "बड़ा करें",
  "dragHint": "स्थिति समायोजित करने के लिए फ़ोटो को खींचें",
  "faqTitle": "प्रश्न और उत्तर",
  "faqSub": "हज और उमरा इबादत से संबंधित सामान्य प्रश्न",
  "healthTitle": "स्वास्थ्य सुझाव",
  "healthSub": "इबादत के दौरान अपनी शक्ति और स्वास्थ्य बनाए रखें",
  "prepTitle": "तैयारी",
  "prepSub": "प्रस्थान से पहले की तैयारी सामग्री",
  "noContentYet": "सामग्री जल्द ही उपलब्ध होगी।"
 }
};
